import { Card, CardContent } from '@/components/ui/card';
import { HugeiconsIcon } from '@hugeicons/react';
import { MotionSection } from '@/components/shared/MotionSection';
import { cn } from '@/lib/utils';

const ICON_TONE = {
  primary: 'bg-[#671E75] shadow-[#671E75]/25',
  blue: 'bg-[#307FE2] shadow-[#307FE2]/25',
  alert: 'bg-amber-500 shadow-amber-500/25',
  danger: 'bg-rose-500 shadow-rose-500/25',
  success: 'bg-emerald-500 shadow-emerald-500/25',
};

export function OperationalPageHeader({ title, subtitle, actions, eyebrow }) {
  return (
    <MotionSection>
      <header className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          {eyebrow && (
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-primary">{eyebrow}</p>
          )}
          <h1 className="font-display text-2xl font-extrabold leading-tight text-foreground md:text-3xl">{title}</h1>
          {subtitle && <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-muted-foreground">{subtitle}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </header>
    </MotionSection>
  );
}

export function OperationalStatCard({ icon, label, value, suffix, subtitle, tone = 'primary' }) {
  return (
    <Card className="rounded-2xl border-border/50 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#671E75]/25 hover:shadow-[0_20px_60px_-15px_rgba(103,30,117,0.12)]">
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
          <div
            className={cn(
              'flex size-8 shrink-0 items-center justify-center rounded-full text-white shadow-lg',
              ICON_TONE[tone] || ICON_TONE.primary,
            )}>
            <HugeiconsIcon icon={icon} className="size-4" aria-hidden="true" />
          </div>
        </div>
        <p className="mt-3 font-display text-3xl font-extrabold tabular-nums text-foreground">
          {value ?? '—'}
          {suffix && <span className="ml-0.5 text-lg font-medium text-muted-foreground">{suffix}</span>}
        </p>
        {subtitle && <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>}
      </CardContent>
    </Card>
  );
}

export function OperationalSectionTitle({ children, description, action }) {
  return (
    <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h2 className="font-display text-lg font-extrabold text-foreground">{children}</h2>
        {description && <p className="mt-1 text-xs text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export const operationalCardClass =
  'rounded-2xl border-border/50 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#671E75]/25 hover:shadow-[0_20px_60px_-15px_rgba(103,30,117,0.12)]';
